var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"main",class:_vm.mealRules.newUI? _vm.btnClass + ' new_radius' : _vm.btnClass,style:(_vm.btnStyle),attrs:{"unselectable":"on","onselectstart":"return false;"},on:{"click":_vm.clickBtn}},[(_vm.modLook)?_c('div',{staticClass:"mod",style:(_vm.mod)}):_vm._e(),_vm._t("btnContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }